module.exports = __webpack_public_path__ + "static/img/app-img-01@m.3a01d6d.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/glovis-aa/app-img-01@m.png
// module id = dcFK
// module chunks = 0